"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = (props, isCopySuccess) => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    layout = 'popup'
  } = props;
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccSocialShareStyle = (0, _react.useMemo)(() => {
    const mobileLayoutProps = () => {
      if (layout === 'inline' && isMobileView) {
        return {
          height: '100%'
        };
      }
      return {};
    };
    const optionsDeviceProps = () => {
      const gridTemplateColumns = isMobileView ? '1fr' : '1fr 1fr';
      const gap = isMobileView ? pxToRem(16) : pxToRem(20);
      return {
        gridTemplateColumns,
        gap
      };
    };
    const optionDeviceProps = () => {
      const height = isMobileView ? pxToRem(50) : pxToRem(60);
      return {
        height
      };
    };
    const optionFeedbackCopiedProps = () => {
      const opacity = isCopySuccess ? 1 : 0;
      return {
        opacity
      };
    };
    const ccSocialShare = (0, _css.css)({
      ...mobileLayoutProps()
    });
    const ccSocialShareOptions = (0, _css.css)({
      display: 'grid',
      paddingTop: pxToRem(20),
      paddingBottom: pxToRem(10),
      ...optionsDeviceProps()
    });
    const ccSocialShareOption = (0, _css.css)({
      position: 'relative',
      ...optionDeviceProps()
    });
    const ccSocialShareOptionInput = (0, _css.css)({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: 'unset',
      opacity: 0,
      pointerEvents: 'none',
      overflow: 'hidden',
      zIndex: -1
    });
    const ccSocialShareOptionFeedback = (0, _css.css)({
      fontSize: pxToRem(14),
      lineHeight: 1,
      paddingBottom: pxToRem(3),
      color: themeColors?.general.success,
      transition: 'opacity 0.5s ease-in-out',
      position: 'absolute',
      top: '0',
      left: 0,
      right: 0,
      transform: 'translate(0, -100%)',
      pointerEvents: 'none',
      userSelect: 'none',
      ...optionFeedbackCopiedProps()
    });
    const ccSocialShareOptionMask = (0, _css.css)({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100% !important',
      height: '100% !important',
      overflow: 'hidden',
      cursor: 'pointer',
      borderRadius: pxToRem(10),
      iframe: {
        position: 'absolute',
        top: '50% !important',
        left: '50% !important',
        transformOrigin: 'center center',
        transform: 'scale(100)'
      }
    });
    return {
      ccSocialShare,
      ccSocialShareOptions,
      ccSocialShareOption,
      ccSocialShareOptionInput,
      ccSocialShareOptionFeedback,
      ccSocialShareOptionMask
    };
  }, [isCopySuccess, isMobileView, layout, pxToRem, themeColors?.general.success]);
  return {
    'cc-SocialShare': ccSocialShareStyle.ccSocialShare,
    'cc-SocialShare__options': ccSocialShareStyle.ccSocialShareOptions,
    'cc-SocialShare__option': ccSocialShareStyle.ccSocialShareOption,
    'cc-SocialShare__option__input': ccSocialShareStyle.ccSocialShareOptionInput,
    'cc-SocialShare__option__feedback': ccSocialShareStyle.ccSocialShareOptionFeedback,
    'cc-SocialShare__option__mask': ccSocialShareStyle.ccSocialShareOptionMask
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;